import { Link } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";

export function AdminHeader({ email, onLogout }) {
  return (
    <header className="sticky top-0 z-40 border-b border-gold/30 bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8">
        <div className="flex items-center gap-3">
          <img src="/brand/logo.png" alt="logo" className="h-10 w-10 rounded-full ring-1 ring-gold/50" />
          <div>
            <p className="font-serif text-lg font-semibold leading-none text-burgundy">Studio Admin</p>
            <p className="text-xs text-plum/60">{email}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            data-testid="admin-view-site-link"
            className="hidden sm:flex items-center gap-1.5 rounded-full border border-burgundy/25 px-4 py-2 text-xs font-medium text-wine transition-all hover:border-gold hover:text-golddeep"
          >
            <ExternalLink className="h-3.5 w-3.5" /> View site
          </Link>
          <button
            onClick={onLogout}
            data-testid="admin-logout-button"
            className="flex items-center gap-1.5 rounded-full border border-burgundy/25 px-4 py-2 text-xs font-medium text-wine transition-all hover:border-red-300 hover:text-red-600"
          >
            <LogOut className="h-3.5 w-3.5" /> Log out
          </button>
        </div>
      </div>
    </header>
  );
}

export function TabBar({ tabs, active, onChange }) {
  return (
    <div className="mb-6 flex flex-wrap gap-2" data-testid="admin-tabs">
      {tabs.map(({ id, label, icon: Icon, testId }) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          data-testid={testId}
          className={`rounded-full border px-5 py-2.5 text-sm font-medium transition-all duration-300 ${
            active === id
              ? "border-gold bg-burgundy text-white shadow-[0_10px_24px_-8px_rgba(123,45,78,0.6)]"
              : "border-burgundy/25 bg-white/75 text-wine hover:border-gold hover:text-golddeep"
          }`}
        >
          <Icon className="mr-1.5 inline h-4 w-4" /> {label}
        </button>
      ))}
    </div>
  );
}
